import { minutesToMilliseconds } from 'date-fns';

export const MAX_MINUTES_ORDER_CHECK = 60 * 12; // 12 hours
export const MIN_SECONDS_WAIT_AFTER_EXITING = 10;
export const QUEUE_BANNER_POLLING_FREQUENCY = minutesToMilliseconds(1);
